import React, { useState, useEffect } from 'react';

import axios from 'axios';
import ServerRow from '../components/ServerRow';
import ServerCreationOverlayVless from '../components/ServerCreationOverlayVless';
import ServerOverlayVless from '../components/ServerOverlayVless';

const GET_LIST_URL = 'https://sasovo.cdn-yandex.net/v2-api/vless/getList';

export default function SettingsVless() {
	const [keys, setKeys] = useState([]);
	const [totalKeys, setTotalKeys] = useState(0);
	const [selectedServer, setSelectedServer] = useState(null);

	const [isServerOverlay, setServerOverlay] = useState(false);
	const [isCreationOverlay, setCreationOverlay] = useState(false);
	const [serversOverview, setServersOverview] = useState(null);

	useEffect(() => {
		getList();
	}, []);

	const getLocalKeys = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const request = await axios.post(GET_LIST_URL, {}, { headers: { Authorization: `Bearer ${token}` } });
		setKeys(request.data.keys);
	};

	const getList = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const request = await axios.post(GET_LIST_URL, {}, { headers: { Authorization: `Bearer ${token}` } });
		const _k = request.data.keys;

		setKeys(request.data.keys);
		countLocalKeys(_k)
		makeOverview(request.data.keys)
	};

	const countLocalKeys = (_k) => {
		let totalAmountOfUsers = 0;
		let countedServers = [];
		for (let i = 0; i < _k.length; i++) {
			const currentServer = _k[i];
			const currentUserCount = parseInt(currentServer.amountofusers);
			if (!countedServers.includes(currentServer.url)) {
				countedServers = [...countedServers, currentServer.url];
				totalAmountOfUsers = totalAmountOfUsers + currentUserCount;
			}
		}
		setTotalKeys(totalAmountOfUsers);
	};

	const makeOverview = (servers_) => {
		let overviewObject = []

		for (let i = 0; i < servers_.length; i++) {
			const currentServer = servers_[i];
			const previousIndex = overviewObject.findIndex((server) => server.plan === currentServer.plan);
			if (previousIndex === -1) {
				overviewObject.push({
					plan: currentServer.plan,
					amountofusers: parseInt(currentServer.amountofusers),
					user_limit: currentServer.user_limit,
				})
			} else {
				let newObject = {
					plan: currentServer.plan,
					amountofusers: parseInt(currentServer.amountofusers) + parseInt(overviewObject[previousIndex].amountofusers),
					user_limit: parseInt(currentServer.user_limit) + parseInt(overviewObject[previousIndex].user_limit),
				}
				overviewObject[previousIndex] = newObject
			}
		}
		setServersOverview(overviewObject)
	}

	const openServer = (id) => {
		console.log({ openServer: id });
		setSelectedServer(id);
		setServerOverlay(true);
	};

	const closeServer = () => {
		setSelectedServer(null);
		setServerOverlay(false);
	};


	const getPlan = (num) => {
		const n = parseInt(num);

		if (n === 0) {
			return 'Base';
		} else if (n === 1) {
			return 'Premium';
		} else if (n === 2) {
			return 'Deeplink';
		} else if (n === 3) {
			return 'Family';
		} else if (n === 4) {
			return '1m / 🇬🇧';
		} else if (n === 5) {
			return '1m / 🇫🇮';
		} else if (n === 6) {
			return '1m / 🇩🇪';
		} else if (n === 7) {
			return '1m / Yota';
		} else if (n === 8) {
			return '6m / 🇬🇧';
		} else if (n === 9) {
			return '6m / 🇫🇮';
		} else if (n === 10) {
			return '1m / 🇺🇸';
		} else if (n === 11) {
			return '6m / Yota';
		} else if (n === 12) {
			return '1m / 🇷🇺';
		} else if (n === 13) {
			return '6m / 🇩🇪';
		} else if (n === 14) {
			return '6m / 🇺🇸';
		} else if (n === 15) {
			return 'Family 1y';
		} else if (n === 99) {
			return 'Trials (99)';
		}

		if (n === 20) {
			return 'Я в Китае';
		}
		if (n === 21) {
			return '6м / Я в Китае';
		}
		if (n === 30) {
			return 'Бизнес';
		}
	};

	return (
		<>
			{isCreationOverlay && <ServerCreationOverlayVless getList={getList} close={() => setCreationOverlay(false)} />}
			{isServerOverlay && <ServerOverlayVless getList={getLocalKeys} close={closeServer} id={selectedServer} />}
			<div className='content-block t-container'>
				<div className='t-content'>
					<div className='page-header'>
						<h1>
							VLESS / <span>{totalKeys}</span>
						</h1>
						<div className='header-buttons-group'>
							<button className='t-button' onClick={(e) => setCreationOverlay(true)}>
								Создать
							</button>
						</div>
					</div>
				</div>
				{serversOverview !== null && <>
					<div className='t-content'>
						<div className='page-header'>
							<h1>Overview</h1>
						</div>
						<table>
							{serversOverview.map((serverByPlan) => {
								return <tr><td>{getPlan(serverByPlan.plan)}</td> <td>{serverByPlan.amountofusers}</td><td> {serverByPlan.user_limit} </td></tr>
							})}
						</table>

					</div>
				</>}


				<div className='row-qiwi labels with-auto-enable vless'>
					<div className='qiwi-column'>Status</div>
					<div className='qiwi-column'>Auto Enable</div>
					<div className='qiwi-column'>Plan</div>
					<div className='qiwi-column'>Id</div>
					<div className='qiwi-column'>Comment</div>
					<div className='qiwi-column'>SNI</div>
					<div className='qiwi-column'>Key</div>
					<div className='qiwi-column'>Users</div>
				</div>

				{keys.map((key) => {
					return <ServerRow type='vless' openServer={openServer} server={key} />;
				})}
			</div>
		</>
	);
}
